<!--
TODO: se comenta debido a futuros banners solo descomentar y reemplazar
<div class="w-full">
  <a
    href="https://republic.com/dexfreight?utm_source=dexfreight&utm_medium=webapp&utm_campaign=republic"
    target="_blank"
    >
    <img [src]="bannerUrl" class="pointer w-100" />
  </a>
</div> -->
<router-outlet></router-outlet>
<dxc-toaster></dxc-toaster>
<dxc-dialog-host></dxc-dialog-host>
<dxc-tour-host></dxc-tour-host>
@if (devModeService.isAvailable) {
  <app-dev-mode-badge></app-dev-mode-badge>
}
@if (emailToLoadProcessing) {
  <div class="email-to-load-processing" role="status" aria-live="polite">
    <span class="dxc-spinner" aria-hidden="true"></span>
    <span>Procesando correos para publicar...</span>
  </div>
}
